import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../catalyst/button';
import InputWithError from '../../catalyst/custom/inputWithError';
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../../catalyst/dialog';
import { ErrorMessage, Field } from '../../catalyst/fieldset';
import { Strong } from '../../catalyst/text';
import Spinning from '../../components/spinning';
import config from '../../config';
import { getCaTypetoName } from '../../utils';

export default function EditSyncModel({sync, editSyncModelOpen, setEditSyncModelOpen}) {

    const navigate = useNavigate();

    const [submitting, setSubmitting] = useState(false)

    const [errors, setErrors] = useState({})
    const [errResponse, setErrResponse] = useState("");

    const [name, setName] = useState(sync.name)

    function createSync() {


        setErrors({})

        if(name.length < 3) {
            setErrors({name: "Please add atleast 3 letters"})
            return
        }

        setSubmitting(true)
        setErrResponse("")

        fetch(config.apiUrl + "/sync/"+sync.id, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
            },
            body: JSON.stringify({name:name}),
        }).then(response => {
            if (!response.ok) {
                throw new Error('Failed to update sync. Please try again or contact us');
            }
            return response;
        })
            .then(response => {
                setEditSyncModelOpen(false)
                setSubmitting(false)
                setErrResponse("")
                window.location.reload();
              })
            .catch(error => {
                setSubmitting(false)
                setErrResponse("Failed to update sync. Please try again or contact us")
            });

    }

    console.log("Rendering")

  return (
    <>
      <Dialog open={editSyncModelOpen} onClose={setEditSyncModelOpen}>
        <DialogTitle>Edit Sync</DialogTitle>
        <DialogDescription>
            Edit sync {<Strong>{sync.name}</Strong>} 
        </DialogDescription>
        <DialogDescription>
            From {<Strong>{getCaTypetoName(sync.transferHistory.sourceAccountType, sync.transferHistory.isSourceYTM)}</Strong>} to {<Strong>{getCaTypetoName(sync.transferHistory.destinationAccountType, sync.transferHistory.isDestYTM)}</Strong>}
        </DialogDescription>
        <DialogBody>
          <InputWithError value={name} error={errors.name} type={"name"} name={"name"} label={"Name"} required={true} onChange={(e) => setName(e.target.value)}/>
          {errResponse && <Field><ErrorMessage>{errResponse}</ErrorMessage></Field>}
        </DialogBody>
        <DialogActions>
          <Button plain onClick={() => setEditSyncModelOpen(false)}>
            Cancel
          </Button>

          <Button onClick={() => {createSync()}} className="w-full" disabled={submitting}>
                        {submitting ? <Spinning /> : "Update"}
            </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
